// Side-effect import — patches console.* so every log line in DevTools
// carries [timestamp] [LEVEL] [file:function] before the original message.
// Load BEFORE App so any module-init logs flow through the formatter.
import './utils/logger'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
